import { render, staticRenderFns } from "./restaurants.vue?vue&type=template&id=1fe28ada&scoped=true&"
import script from "./restaurants.vue?vue&type=script&lang=js&"
export * from "./restaurants.vue?vue&type=script&lang=js&"
import style0 from "./restaurants.vue?vue&type=style&index=0&id=1fe28ada&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe28ada",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fe28ada')) {
      api.createRecord('1fe28ada', component.options)
    } else {
      api.reload('1fe28ada', component.options)
    }
    module.hot.accept("./restaurants.vue?vue&type=template&id=1fe28ada&scoped=true&", function () {
      api.rerender('1fe28ada', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/restaurants/restaurants.vue"
export default component.exports